import { useRef, useEffect } from 'react';
import { BEYOND } from '@/config/assets';

export default function BeyondSection() {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) e.target.querySelectorAll('.reveal-el').forEach(c => c.classList.add('visible')); }, { threshold: 0.1 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <section data-testid="beyond-section" ref={ref} className="relative min-h-[60vh] md:min-h-[70vh] flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img src={BEYOND.image} alt="" className="w-full h-full object-cover opacity-20" loading="lazy" />
        <div className="absolute inset-0" style={{ background: 'linear-gradient(to top, var(--deep-black), rgba(10,10,10,0.6), rgba(10,10,10,0.4))' }} />
      </div>
      <div className="relative z-10 px-5 md:px-10 text-center py-24 md:py-40">
        <p className="reveal-el font-['Cormorant_Garamond'] text-xs tracking-[0.3em] uppercase mb-10" style={{ color: 'var(--gold)', opacity: 0.5 }}>Beyond</p>
        <h2 className="reveal-el font-['Playfair_Display'] italic text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-normal leading-none" style={{ color: 'var(--warm-cream)' }}>
          What comes <span className="font-semibold" style={{ color: 'var(--gold)' }}>next</span>.
        </h2>
      </div>
    </section>
  );
}
